<template lang="pug">
  form(@submit.prevent="next")
    p.text-large - Informações do Documento
    .columns
      .column.col-6.col-md-8.col-sm-12
        .columns
          .column.col-12
            form-group(:label="'doc.cadastro' | tModel" :validation="$v.resource.cadastro_id")
              cadastro-picker(
                v-model="$v.resource.cadastro_id.$model"
                @selected="onSelectCadastro"
              )
          .column.col-12
            form-group(:label="'doc.local' | tModel" :validation="$v.resource.local.cadastro_id")
              cadastro-picker(
                v-model="$v.resource.local.cadastro_id.$model"
                :disabled="!resource.cadastro_id"
                @selected="onSelectLocal"
              )
          .column.col-12
            form-group(:label="'doc_local.vistoria_em' | tModel" :validation="$v.resource.local.vistoria_em")
              datepicker(
                v-model="$v.resource.local.vistoria_em.$model"
                :disabled="!resource.cadastro_id"
                format='DD/MM/YYYY HH:mm'
                type='datetime'
              )
          .column.col-12
            form-group(label='Descrição/Motivação' :validation="$v.resource.local.descricao")
              input.form-input(v-model="$v.resource.local.descricao.$model" :disabled="!resource.cadastro_id")
          .column.col-12
            form-group(:label="'doc.fiscal' | tModel" :validation="$v.resource.fiscal_id")
              fiscal-picker(
                v-model="$v.resource.fiscal_id.$model"
                @selected="onSelectFiscal"
              )
          .column.col-12
            form-group(:label="'doc.tipo' | tModel" :validation="$v.resource.tipo")
              output.form-input.disabled {{ resource | enums('doc.tipo') }}
          .column.col-6.col-sm-12
            form-group(:label="'doc.prazo_regularizar' | tModel" :validation="$v.resource.prazo_regularizar")
              input.form-input(type="number" v-model.number="$v.resource.prazo_regularizar.$model")
    .pt-2
      .divider
      button.btn.btn-primary(:disabled="$v.resource.$invalid")
        btn-content(name="next")
</template>

<script>
import createMixin from './mixin'
import { minValue, required } from 'vuelidate/lib/validators'
import User from '@/lib/User'

export default {
  mixins: [createMixin],
  computed: {
    tiposDeEntrega() {
      return this.$i18n.t('enums.db.enum_ciencia_tipo')
    },
  },
  methods: {
    onSelectCadastro(cadastro = {}) {
      this.resource.cadastro = cadastro
      this.resource.local.cadastro = cadastro
      this.resource.local.cadastro_id = cadastro.id
    },
    onSelectFiscal(fiscal = {}) {
      this.resource.fiscal = fiscal
    },
    onSelectLocal(cadastro = {}) {
      this.resource.local.cadastro = cadastro
    },
  },
  created() {
    if (!this.resource.fiscal_id) this.resource.fiscal_id = User.current.id
    if (!this.resource.fiscal) this.resource.fiscal = User.current
  },
  validations: {
    resource: {
      cadastro_id: { required },
      fiscal_id: { required },
      local: {
        cadastro_id: {},
        descricao: {},
        vistoria_em: {},
      },
      tipo: { required },
      prazo_regularizar: { required, minValue: minValue(0) },
    },
  },
}
</script>
